import styled from 'styled-components';
import Button from '../../../Shared/VaultButton';

export const DeleteButton = styled(Button)`
  position: absolute;
  left: 0px;
  margin-right: 0.5rem;
  svg {
    width: 1rem;
    height: 1rem;
  }
`;
